import { z } from 'zod'
import QuestionWrapper from '../../questionnaire/formSteps/QuestionWrapper'
import { QuestionFlowEnum } from '@strata-monorepo/shared-types'

export const texasMoveOptions = [
  { label: 'Yes, I am moving from outside of Texas', value: 'yes' },
  { label: 'No, I am already a Texas resident', value: 'no' },
]

export const texasMove = {
  component: QuestionWrapper,
  componentProps: {
    type: 'radio',
    title: 'Are you moving to Texas from another state?',
    label: 'Home details',
    subtitle: 'Select an option.',
    options: texasMoveOptions,
    formValue: 'nonTexasNative',
    tooltip:
      "If you're already a Texas resident, we can compare your current plan to the latest rates and make sure you're getting the best rate.",
    canSkip: true,
    tracking: {
      stepName: 'Moving to Texas',
      deepStepNumber: 2,
      quickStepNumber: 2,
      deepStepId: '2',
      quickStepId: '2',
      fieldName: 'moving_to_tx',
    },
  },
  name: 'texasMoveRadioGroup',
  schema: z.object({
    nonTexasNative: z.string().optional(),
  }),
  coreIf: {
    operator: '&&',
    conditions: [
      {
        formStepKey: 'interstitial',
        comparisonOperator: '===',
        expectedAnswer: QuestionFlowEnum.DEEP_DIVE,
      },
      {
        formStepKey: 'moving',
        comparisonOperator: '===',
        expectedAnswer: 'yes',
      },
    ],
  },
  visibleIf: {
    operator: '&&' as const,
    conditions: [
      {
        formStepKey: 'interstitial',
        comparisonOperator: '===' as const,
        expectedAnswer: QuestionFlowEnum.DEEP_DIVE,
      },
      {
        formStepKey: 'moving',
        comparisonOperator: '===' as const,
        expectedAnswer: 'yes',
      },
    ],
  },
}
